import { FormInputsHeader } from "features/CenterContent/RoleContent/ProductionDeviation/components/FormInputsHeader";
import { ProductionDeviationSteps } from "features/CenterContent/RoleContent/ProductionDeviation/ProductionDeviationModal";
import { SelectTrainIds } from "features/CenterContent/RoleContent/ProductionDeviation/steps/SelectTrainIds";
import { OperationalInformationTypes } from "features/CenterContent/shared/operationalInformation/hooks/useOperationalInformationTypes";
import { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { HStack, Text } from "shared/components/Spor";
import { StepActionModal } from "shared/components/StepActionModal";
import { DropsStepper } from "shared/components/stepper/DropsStepper";

type SelectTrainIdsModalProps = {
  isEditMode: boolean;
  setActiveStep: Dispatch<SetStateAction<number>>;
  selectedTrains: string[];
  onClose: () => void;
  trainSeriesIndex: number;
  setTrainSeriesIndex: Dispatch<SetStateAction<number>>;
  trainSeries: string[];
  opInfoData: OperationalInformationTypes;
  trigger: () => Promise<boolean>;
};

export const SelectTrainIdsModal: FC<SelectTrainIdsModalProps> = ({
  isEditMode,
  setActiveStep,
  selectedTrains,
  onClose,
  trainSeriesIndex,
  setTrainSeriesIndex,
  trainSeries,
  opInfoData,
  trigger,
}) => {
  const { t } = useTranslation();
  return (
    <StepActionModal
      title={`${isEditMode ? t("Endre") : t("Opprett")} ${t("produksjonsavvik")}`}
      actionTitle={`${t("Se oppsummering")} →`}
      withBackButton
      onBack={() => setActiveStep(ProductionDeviationSteps.FORM)}
      isSubmitDisabled={selectedTrains.length === 0}
      onStep={trigger}
      onSubmit={() => setActiveStep(ProductionDeviationSteps.OVERVIEW)}
      onClose={onClose}
      loading={false}
      isSuccess={false}
      isError={false}
      successMessage=""
      failureMessage=""
      activeStep={trainSeriesIndex}
      setActiveStep={setTrainSeriesIndex}
      trainSeries={trainSeries}
      shouldWrapChildren={false}
      subHeaders={[
        <FormInputsHeader
          trainSeries={trainSeries}
          trainSeriesIndex={trainSeriesIndex}
          opInfoData={opInfoData}
          toFormInputsStep={() => setActiveStep(ProductionDeviationSteps.FORM)}
        />,
        <HStack alignItems="center">
          <Text variant="xs">{t("Velg berørte tog for togserie")}:</Text>
          <DropsStepper
            onClick={(step) => setTrainSeriesIndex(step)}
            activeStep={trainSeriesIndex}
            steps={trainSeries}
            variant="core"
          />
        </HStack>,
      ]}
    >
      <SelectTrainIds
        trainSeries={trainSeries}
        index={trainSeriesIndex}
        opInfoData={opInfoData}
        mode={isEditMode ? "edit" : "create"}
      />
    </StepActionModal>
  );
};
